function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleQuestionThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    d: "M 22.5 12 C 22.5 6.199219 17.800781 1.5 12 1.5 C 6.199219 1.5 1.5 6.199219 1.5 12 C 1.5 17.800781 6.199219 22.5 12 22.5 C 17.800781 22.5 22.5 17.800781 22.5 12 Z M 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 Z M 7.90625 7.960938 C 8.210938 6.804688 9.253906 6 10.449219 6 L 13.125 6 C 14.789062 6 16.125 7.359375 16.125 9.015625 C 16.125 10.140625 15.496094 11.179688 14.488281 11.695312 L 12.75 12.578125 L 12.75 13.5 C 12.75 13.914062 12.414062 14.25 12 14.25 C 11.585938 14.25 11.25 13.914062 11.25 13.5 L 11.25 12.117188 C 11.25 11.835938 11.410156 11.578125 11.65625 11.445312 L 13.804688 10.351562 C 14.304688 10.097656 14.625 9.570312 14.625 9.003906 C 14.625 8.171875 13.949219 7.492188 13.125 7.492188 L 10.449219 7.492188 C 9.9375 7.492188 9.488281 7.835938 9.359375 8.328125 L 9.351562 8.363281 C 9.25 8.761719 8.835938 9.003906 8.4375 8.898438 C 8.039062 8.789062 7.796875 8.382812 7.902344 7.984375 L 7.914062 7.949219 Z M 10.875 16.5 C 10.875 15.878906 11.378906 15.375 12 15.375 C 12.621094 15.375 13.125 15.878906 13.125 16.5 C 13.125 17.121094 12.621094 17.625 12 17.625 C 11.378906 17.625 10.875 17.121094 10.875 16.5 Z M 10.875 16.5 ",
    fill: "#149CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionThin);
export default __webpack_public_path__ + "static/media/circle-question-thin.b249a7bf07ac363caff78158318e559e.svg";
export { ForwardRef as ReactComponent };